import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelAQuestionButton({onClick}) {
    // Used in LevelAMetaData to display info button when
    // LevelA has description

    // BUILD
    if (isNullOrUndefined(onClick))
        return null
    return (
        <div className={"mt-[2px] cursor-pointer flex justify-center items-center rounded-full w-[16px] min-w-[16px] h-[16px] min-h-[16px] bg-greyLight5 hover:bg-greyLight7"}
             onClick={onClick}>
            <span className={`text-[12px] text-black font-normal`}>
                {"?"}
            </span>
        </div>
    );
}